import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from '../assets/fr.json'
import en from '../assets/en.json'

Vue.use(VueI18n);
export const i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: {
        'en': en,
        'fr': fr
    }
})
